/**
 * Endpoint 3 — GET calculator/app/pageurl (research/07 §3; REQ-BOOT-7).
 * URL carries the raw location.href UNENCODED; JSON returned iff
 * response.ok && status !== 204, else null; a rejected fetch propagates
 * (no catch — the unhandled rejection IS the error UI, research/01 Q3/Q4).
 */
import { appState } from "../state/app-state";
import { resolution } from "./calculator-resolve";

export async function getNonProductByPageUrl(pageUrl: string): Promise<any> {
  // DIV-027: the resolve call already answered this. Same shape the pageurl
  // endpoint returns (calcUniqueIden + elementSelector), or null.
  const resolved = await resolution();
  if (resolved !== "unavailable") {
    if (resolved !== "none" && resolved.mode === "nonproduct") {
      return { calcUniqueIden: resolved.calculatorId, elementSelector: resolved.elementSelector };
    }
    return null;
  }
  var url = `${appState.baseCalculatorNewApiUrl}calculator/app/pageurl?pageUrl=${pageUrl}`;
  const response = await fetch(url);
  if (response.ok && response.status !== 204) return await response.json();

  return null;
}
